/**
 * Abstract class defining the interface for message transport helpers.
 * Handles encoding/decoding of messages for different transport formats.
 */
export abstract class TransportHelper<MSG, DATA> {
  /**
   * Encodes a Message object into the transport format T.
   */
  abstract encode(msg: MSG): DATA;
  /**
   * Decodes a message from the transport format (unknown/any) into a Message object.
   */
  abstract decode(msg: unknown): MSG;
}
